import { RecipeService } from "@/services/models/recipe/recipe";
const moduleQx = {
  namespaced: true,
  state: {
    recipes: [],
    loading: false,
    page: 1,
  },
  getters: {
    getRecipes(state) {
      return state.recipes;
    },
    getLoading(state) {
      return state.loading;
    },
    getPage(state) {
      return state.page;
    },
  },
  mutations: {
    loadRecipes(state, recipes) {
      state.recipes = recipes;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setPage(state, page) {
      state.page = page;
    },
  },
  actions: {
    async loadRecipes({ commit, state, rootGetters }) {
      state.loading = true;
      const PAGE = rootGetters["recipesOtherNodes/getPage"];
      const RUT = rootGetters["patient/getPatientRut"];
      commit("loadRecipes", []);
      commit("setLoading", true);
      let recipes = await RecipeService.getByOtherCenters(
        {
          origin_node_id: JSON.parse(window.localStorage.getItem("stablishment")),
          rut: RUT.replaceAll(".", "").replaceAll("-", ""),
        },
        PAGE
      );
      commit("loadRecipes", recipes);
      commit("setLoading", false);
      state.loading = false;
    },
  },
};

export default moduleQx;
